module.exports = __webpack_public_path__ + "static/media/kun-8.jpeg";